import React, {useEffect, useState} from 'react';
import { useRecipesPageData } from '../hooks/useRecipesData';
import TakisHero from "../components/TakisHero"
import TakisRecipeList from '../components/TakisRecipeList';
import TakisHeroSkeleton from "../components/Skeletons/TakisHeroSkeleton"
import TakisRecipeListSkeleton from "../components/Skeletons/TakisRecipeListSkeleton"

const Recipes = ({pagePath, pageType}) => {
  const [recipesPageData, setRecipesPageData] = useState('');
  const { error, isLoading, recipesPageQueryData } = useRecipesPageData(pagePath);

  useEffect(() => {
    if (recipesPageQueryData) {
      setRecipesPageData(recipesPageQueryData);
    }
  }, [recipesPageQueryData]);

  if (isLoading || error || !recipesPageData) {
    return (
      <>
        <TakisHeroSkeleton/>
        <TakisRecipeListSkeleton/>
      </>
    );
  }

  return (
    <>
      <TakisHero data={recipesPageData.hero}/>
      <TakisRecipeList
        pageType={pageType}
        title={recipesPageData.recipesComponent.title}
        recipeCTA={recipesPageData.recipesComponent.recipeCTA}
        recipesPageCTA={recipesPageData.recipesComponent.recipesPageCTA}
        isSectionTitle={true}
      />
    </>
  );
};

export default Recipes;
